import React, { useState } from "react";
import StepChart from "./StepChart/StepChart";
import styles from "./CommunityAreaProfiles.module.css";
import * as d3 from "d3";
import Table from "./Table/Table";
import {
  color,
  calculateRank,
  year,
  getCurrentYear,
  getPreviousYear,
} from "../../helperFunctions";
import SummarySentence from "./SummarySentence/SummarySentence";

const text_color = d3
  .scaleThreshold()
  .domain([-15, -10, -5, -1, 1, 5, 10, 15])
  .range([
    "#fff",
    "#000",
    "#000",
    "#000",
    "#000",
    "#000",
    "#000",
    "#000",
    "#fff",
  ]);

const determineTEXT = d3
  .scaleThreshold()
  .domain([-15, -10, -5, -1, 1, 5, 10, 15])
  .range([
    "Less Violent",
    "Less Violent",
    "Less Violent",
    "Less Violent",
    "SIMILAR VIOLENCE",
    "More Violent",
    "More Violent",
    "More Violent",
    "More Violent",
  ]);

const CommunityAreaProfile = ({ data, updated }) => {
  return (
    <div>
      {data.map((d, i) => {
        const rank = calculateRank(
          d[1].victimizations,
          updated,
          d[1].population
        );
        return (
          <React.Fragment>
            {i ? <hr /> : null}
            <div
              className={styles.Profile}
              id={d[0].split(" ").join("").toLowerCase()}
            >
              <h3>
                {i + 1}. {d[0].toLowerCase()}
              </h3>
              <p
                className={styles.Tag}
                style={{
                  backgroundColor: color(rank),
                  color: text_color(rank),
                }}
              >
                {determineTEXT(rank)}
              </p>
              <div className={styles.Stats}>
                <div>
                  <p>
                    Population: <span>{d3.format(",")(d[1].population)}</span>
                  </p>
                </div>
                <div>
                  <p>
                    Total victim gap between {year} and {year - 1}:{" "}
                    <span>
                      {" "}
                      {d3.format("+")(
                        getCurrentYear(d[1].victimizations, updated).length -
                          getPreviousYear(d[1].victimizations, updated).length
                      )}
                    </span>
                  </p>
                  <p>
                    Per Capita gap between {year} and {year - 1}:{" "}
                    <span>{d3.format("+.1f")(rank)}</span>
                  </p>
                </div>
              </div>
              <div className={styles.Chart}>
                <StepChart
                  id={d[0].split(" ").join("") + "TS"}
                  data={d}
                  updated={updated}
                />
              </div>
              <SummarySentence
                data={d}
                updated={updated}
                rank={i}
                rankVal={rank}
              />
              <div>
                <Table data={d} updated={updated} />
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CommunityAreaProfile;
